import { render } from "./NewParametersCard.vue?vue&type=template&id=2431e77b&scoped=true"
import script from "./NewParametersCard.vue?vue&type=script&lang=js"
export * from "./NewParametersCard.vue?vue&type=script&lang=js"

import "./NewParametersCard.vue?vue&type=style&index=0&id=2431e77b&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2431e77b"]])

export default __exports__